import React from "react";
import MatchResult from "./MatchResult";
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import Header from "components/Header/Header";
import RightGif from "components/RightGif";

const PrizeStructure = () => {
    return (
      <div
        className={twMerge(SITE, 'w-full h-full')}
        style={{ fontFamily: "'Times New Roman', Times, serif" }}
      >
        <img
          src="bg.png"
          alt="Background"
          className="w-full h-screen fixed top-0 left-0 object-cover block"
          style={{ zIndex: 0 }}
        />
        {/* <div className="fixed bottom-0 left-0 w-auto max-w-[min(40vw,280px)] 2xl:max-w-[320px] hidden xl:block leading-none pointer-events-none z-[1]">
                <img src="/lv_left.png" alt="" className="block w-full h-full object-contain object-left-bottom" />
            </div>
            <div className="fixed bottom-0 right-0 w-auto max-w-[min(50vw,420px)] 2xl:max-w-[500px] hidden xl:block leading-none pointer-events-none z-[1]">
                <img src="/lv_right.png" alt="" className="block w-full h-full object-contain object-right-bottom" />
            </div> */}
        <RightGif />
        <div className="container relative z-10">
          <Header />

          {/* Header Cơ Cấu Giải Thưởng */}
          <div className="hidden flex justify-center items-start md:p-10 p-5 mt-10 mb-4 w-full h-auto min-h-[280px] relative bg-white rounded-[15px]">
            <div className="absolute top-[-25px] left-1/2 transform -translate-x-1/2 w-full md:max-w-[250px] max-w-[220px]">
              <img
                src="/assets/images/cocau/title.png"
                alt=""
                className="w-full h-full object-contain"
              />
            </div>

            {/* Bảng Cơ Cấu Giải Thưởng từ Figma */}
            <div className="w-full max-w-4xl mx-auto mt-8 px-2">
              <table
                className="w-full text-center font-['Times_New_Roman']"
                style={{ borderCollapse: 'collapse', fontFamily: 'Times New Roman' }}
              >
                <thead>
                  <tr style={{ borderBottom: '1px solid black' }}>
                    <th className="text-sm sm:text-base md:text-lg font-['Times_New_Roman'] font-bold text-[#157f3d] pb-3 sm:pb-4">
                      Cấp độ VIP
                    </th>
                    <th className="text-sm sm:text-base md:text-lg font-['Times_New_Roman'] font-bold text-[#157f3d] pb-3 sm:pb-4">
                      Dự Đoán Tỷ Số
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: '1px solid black' }}>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      VIP 0
                    </td>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      29
                    </td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid black' }}>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      VIP 1 - VIP 5
                    </td>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      99
                    </td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid black' }}>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      VIP 6 - VIP 10
                    </td>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      299
                    </td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid black' }}>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      VIP 11 - VIP 15
                    </td>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      599
                    </td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid black' }}>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      VIP 16 - VIP 25
                    </td>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      999
                    </td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid black' }}>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      VIP 26 - VIP 30
                    </td>
                    <td className="text-xs sm:text-sm md:text-base font-['Times_New_Roman'] font-normal text-[#333333] py-2 sm:py-2.5 md:py-3">
                      1399
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <MatchResult />
        </div>
      </div>
    );
};

export default PrizeStructure;
